import script from "./ActivitiesAndEvents.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivitiesAndEvents.vue?vue&type=script&setup=true&lang=js"

import "./ActivitiesAndEvents.vue?vue&type=style&index=0&id=71a0bd19&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71a0bd19"]])

export default __exports__